import configJson from './auth_config.json'
import { QueryClient } from '@tanstack/react-query'

export function getConfig() {
  const audience = configJson.audience ? configJson.audience : null

  return {
    domain: configJson.domain,
    clientId: configJson.clientId,
    ...(audience ? { audience } : null)
  }
}

export const queryClient = new QueryClient()

export const apiBaseUrl = import.meta.env.VITE_PASSWORDS_API_URL
export const contactUsApiBaseUrl = import.meta.env.VITE_CONTACT_US_API_URL
